import { Box, Stack, Typography } from "@mui/material";

const border = "1px solid #666";
const backgroundColor = "hsla(250, 86%, 97%, 1)";
const fontSize = "14px";

export const columns = [
  // {
  //   accessorKey: "Components",
  //   header: "Material Code",
  //   size: 120,
  //   enableSorting: false,
  //   // muiTableHeadCellProps: { align: "center" },
  // },
  {
    accessorKey: "Cost Code ",
    header: "Cost Code",
    size: 100,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Description",
    header: "Material Description",
    size: 290,
    enableHiding: false,
    enableSorting: false,
    // muiTableHeadCellProps: { align: "center" },
  },
  {
    accessorKey: "Cost (US $)",
    header: "Est. Material Cost $",
    Header: (
      <div>
        <div>Estimated</div>
        <div>Material Cost</div>
        <div>($)</div>
      </div>
    ),
    size: 90,
    enableSorting: false,
    muiTableBodyCellProps: { align: "right" },
    // muiTableHeadCellProps: { align: "center" },
    Footer: () => (
      <Stack>
        <Box color="warning.main" sx={{ textAlign: "center" }}>
          {/* {getValues("totalMaterialCost") || 0} */}
        </Box>
      </Stack>
    ),
  },
  {
    accessorKey: "actual_cost",
    header: "Actual Material Cost $",
    Header: (
      <div>
        <div>Actual</div>
        <div>Material Cost</div>
        <div>($)</div>
      </div>
    ),
    size: 90,
    enableSorting: false,
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => (
      <>
        {cell.getValue() ? (
          Math.round(cell.getValue()) ? (
            <Typography color={"green"}>
              {Math.round(cell.getValue())}
            </Typography>
          ) : (
            <Typography color={"red"}>Not bought yet</Typography>
          )
        ) : (
          <Typography color={"red"}>Not bought yet</Typography>
        )}
      </>
    ),
    // muiTableHeadCellProps: { align: "center" },
    Footer: () => (
      <Stack>
        <Box color="warning.main" sx={{ textAlign: "center" }}>
          {/* {getValues("totalMaterialCost") || 0} */}
        </Box>
      </Stack>
    ),
  },
  // {
  //   accessorKey: "Total Manhour",
  //   header: "Total Manhour",
  //   muiTableBodyCellProps: { align: "right" },
  //   // muiTableHeadCellProps: { align: "center" },
  //   Header: (
  //     <div>
  //       <div>Est.</div>
  //       <div>FAB Hours</div>
  //       {/* <div>Hours</div> */}
  //     </div>
  //   ),
  //   Cell: ({ cell }) => (
  //     <>{cell.getValue() ? Math.round(cell.getValue()) : ""}</>
  //   ),
  //   size: 80,
  //   enableSorting: false,
  // },
  // {
  //   accessorKey: "actual_hours",
  //   header: "Actual FAB Hrs",
  //   Header: (
  //     <div>
  //       <div>Actual</div>
  //       <div>FAB Hours</div>
  //       {/* <div>Hours</div> */}
  //     </div>
  //   ),
  //   size: 90,
  //   enableSorting: false,
  //   muiTableBodyCellProps: { align: "right" },
  //   Cell: ({ cell }) => (
  //     <>{cell.getValue() ? Math.round(cell.getValue()) : ""}</>
  //   ),
  //   // muiTableHeadCellProps: { align: "center" },
  //   // Cell: ({ cell }) => (<>{cell.getValue()?.split(".")[0]}</>),
  //   Footer: () => (
  //     <Stack>
  //       <Box color="warning.main" sx={{ textAlign: "center" }}>
  //         {/* {getValues("totalHours") || 0} */}
  //       </Box>
  //     </Stack>
  //   ),
  // },
  {
    accessorKey: "Remarks",
    header: "Remarks",
    enableSorting: false,
    // muiTableHeadCellProps: { align: "center" },
    size: 100,
  },
  // ...othercolumns
];

export const columns2 = () => [
  // {
  //   accessorKey: "Components",
  //   header: "Material Code",
  //   size: 120,
  //   enableSorting: false,
  //   // muiTableHeadCellProps: { align: "center" },
  // },
  {
    accessorKey: "costCode",
    header: "Cost Code",
    size: 100,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "description",
    header: "Material Description",
    size: 200,
    enableHiding: false,
    enableSorting: false,
    // muiTableHeadCellProps: { align: "center" },
  },
  // {
  //   accessorKey: "quantity",
  //   header: "Quantity",
  //   Header: (
  //     <div>
  //       <div>Quantity</div>
  //     </div>
  //   ),
  //   size: 50,
  //   enableSorting: false,
  //   muiTableBodyCellProps: { align: "right" },
  // },

  {
    accessorKey: "Cost (US $)",
    header: "Estimated",
    size: 90,
    enableSorting: false,

    AggregatedCell: ({ row }) => {
      const total = row.subRows.reduce(
        (acc, curr) =>
          acc + (Number(row.original.estCost * row.original.quantity) || 0),
        0
      );
      return (
        <Typography color="primary" fontWeight="bold">
          Total: ${Math.round(total)}
        </Typography>
      );
    },
    muiTableHeadCellProps: {
      align: "center",
      sx: {
        border,
        borderRight: "none",
        backgroundColor,
        fontSize,
        pt: 2,
      },
    },
    columns: [
      {
        accessorKey: "estQuantity",
        header: "Qty",
        size: 40,
        enableSorting: false,
        // muiTableBodyCellProps: { align: "right" },
        // Cell: ({ row }) => {
        //   console.log("est pms row", row.original);
        // },
        muiTableHeadCellProps: {
          align: "center",
          sx: {
            borderLeft: border,
            backgroundColor,
            fontSize,
            borderRight: "1px solid rgba(224,224,224,1)",
          },
        },
        muiTableBodyCellProps: {
          align: "center",
          sx: {
            borderLeft: border,
            borderRight: "1px solid rgba(224,224,224,1)",
          },
        },
      },
      {
        accessorKey: "estUnit",
        header: "Unit",
        size: 40,
        enableSorting: false,
        Cell: ({ row }) => row.original.unit,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        accessorKey: "estCost",
        header: "Cost",
        size: 40,
        enableSorting: false,
        // muiTableBodyCellProps: { align: "right" },
        // Cell: ({ row }) => {
        //   // console.log("row ssssssss", row.original);
        //   return row.original.estCost * row.original.estQuantity || "";
        // },
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
    ],
  },
  {
    accessorKey: "actual_cost",
    header: "Actual",
    size: 90,
    enableSorting: false,
    AggregatedCell: ({ row }) => {
      // console.log("row", row?.original);
      const total = row.subRows.reduce(
        (acc, curr) => acc + (Number(row.original.poMaterials?.[0]?.cost) || 0),
        0
      );
      return (
        <Typography color="primary" fontWeight="bold">
          Total: ${Math.round(total)}
        </Typography>
      );
    },
    // muiTableHeadCellProps: { align: "center" },
    Footer: () => (
      <Stack>
        <Box color="warning.main" sx={{ textAlign: "center" }}>
          {/* {getValues("totalMaterialCost") || 0} */}
        </Box>
      </Stack>
    ),
    muiTableHeadCellProps: {
      align: "center",
      sx: {
        border,
        backgroundColor,
        fontSize,
        pt: 2,
      },
    },
    columns: [
      {
        accessorKey: "actualQuantity",
        header: "Qty",
        size: 40,
        enableSorting: false,
        // muiTableBodyCellProps: { align: "right" },
        // Cell: ({ row }) => {
        //   console.log("rowwwwww", row.original);
        //   return row.original.procuredQty || "";
        // },
        muiTableHeadCellProps: {
          align: "center",
          sx: {
            borderLeft: border,
            backgroundColor,
            fontSize,
            borderRight: "1px solid rgba(224,224,224,1)",
          },
        },
        muiTableBodyCellProps: {
          align: "center",
          sx: {
            borderLeft: border,
            borderRight: "1px solid rgba(224,224,224,1)",
          },
        },
      },
      {
        accessorKey: "unit",
        header: "Unit",
        size: 40,
        enableSorting: false,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        accessorKey: "actualCost",
        header: "Cost",
        size: 40,
        enableSorting: false,
        muiTableBodyCellProps: { align: "right" },
        // Cell: ({ row }) =>
        //   row.original.actualCost * row.original.actualQuantity || "",
        muiTableHeadCellProps: {
          align: "center",
          sx: { borderRight: border, backgroundColor, fontSize },
        },
        muiTableBodyCellProps: {
          align: "center",
          sx: { borderRight: border },
        },
      },
    ],
  },
  {
    accessorKey: "Defference %",
    header: "Defference %",
    Header: (
      <div>
        <div>Difference %</div>
      </div>
    ),
    size: 100,
    enableSorting: false,
    // muiTableBodyCellProps: { align: "right" },
    Cell: ({ row }) => {
      const est = Number(row.original.estCost) || 0;
      const actual = Number(row.original.actualCost) || 0;

      // nothing to show
      if (!est && !actual) return <Typography>-</Typography>;
      // estimated is zero but actual exists -> can't compute %
      if (!est) return <Typography color="warning.main">N/A</Typography>;

      const diffPercent = ((actual - est) / est) * 100;
      // const rounded = Math.round(diffPercent);
      const rounded = diffPercent?.toFixed(2);
      const color = rounded > 0 ? "red" : rounded < 0 ? "green" : "textPrimary";
      const plus = rounded > 0 ? "+" : "";
      return (
        <Typography color={color}>
          {plus}
          {rounded} %
        </Typography>
      );
    },
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  // {
  //   accessorKey: "Est.FAB HoursHours",
  //   header: "Est.FAB HoursHours",
  //   Header: (
  //     <div>
  //       <div>Est.</div>
  //       <div>FAB Hours</div>
  //       <div>Hours</div>
  //     </div>
  //   ),
  //   size: 90,
  //   enableSorting: false,
  //   muiTableBodyCellProps: { align: "right" },
  //   Cell: ({ cell }) => <></>,
  //   AggregatedCell: ({ row }) => {
  //     const total = fabData[row.original["Cost Code "]]?.totalManHours || 0;
  //     return (
  //       <Typography color="primary" fontWeight="bold">
  //         {total || 0}
  //       </Typography>
  //     );
  //   },
  //   // muiTableHeadCellProps: { align: "center" },
  //   Footer: () => (
  //     <Stack>
  //       <Box color="warning.main" sx={{ textAlign: "center" }}>
  //         {/* {getValues("totalMaterialCost") || 0} */}
  //       </Box>
  //     </Stack>
  //   ),
  // },
  // {
  //   accessorKey: "Actual FAB HoursHours",
  //   header: "Actual FAB HoursHours",
  //   Header: (
  //     <div>
  //       <div>Actual</div>
  //       <div>FAB Hours</div>
  //       <div>Hours</div>
  //     </div>
  //   ),
  //   size: 90,
  //   enableSorting: false,
  //   muiTableBodyCellProps: { align: "right" },
  //   Cell: ({ cell }) => <></>,
  //   AggregatedCell: ({ row }) => {
  //     const total = fabData[row.original["Cost Code "]]?.actual_cost || 0;
  //     return (
  //       <Typography color="primary" fontWeight="bold">
  //         {total || 0}
  //       </Typography>
  //     );
  //   },
  //   // muiTableHeadCellProps: { align: "center" },
  //   Footer: () => (
  //     <Stack>
  //       <Box color="warning.main" sx={{ textAlign: "center" }}>
  //         {/* {getValues("totalMaterialCost") || 0} */}
  //       </Box>
  //     </Stack>
  //   ),
  // },
  // {
  //   accessorKey: "Weight (lb)",
  //   header: "Weight (lb)",
  //   Header: (
  //     <div>
  //       <div>Weight</div>
  //       <div>(lb)</div>
  //       {/* <div>Hours</div> */}
  //     </div>
  //   ),
  //   size: 90,
  //   enableSorting: false,
  //   muiTableBodyCellProps: { align: "right" },
  //   Cell: ({ cell }) => <>{cell.getValue()}</>,
  //   AggregatedCell: ({ row }) => {
  //     const total = row.subRows.reduce(
  //       (acc, curr) => acc + (Number(curr.original["Weight (lb)"]) || 0),
  //       0
  //     );
  //     return (
  //       <Typography color="primary" fontWeight="bold">
  //         Total: {Math.round(total)}
  //       </Typography>
  //     );
  //   },
  //   // muiTableHeadCellProps: { align: "center" },
  //   Footer: () => (
  //     <Stack>
  //       <Box color="warning.main" sx={{ textAlign: "center" }}>
  //         {/* {getValues("totalMaterialCost") || 0} */}
  //       </Box>
  //     </Stack>
  //   ),
  // },
  {
    accessorKey: "Remarks",
    header: "Remarks",
    enableSorting: false,
    // muiTableHeadCellProps: { align: "center" },
    size: 200,
  },
  // ...othercolumns
];
